const ReviewCheckStatus = Object.freeze({
    PASSED: 'passed',
    NEEDS_REVIEW: 'needs_review',
})

const isNonEmpty = value => typeof value === 'string' && value.trim().length > 0

const defaultSubstanceChecker = ({ substance, link }) => ({
    checks: [
        {
            id: 'name',
            status: isNonEmpty(substance.name)
                ? ReviewCheckStatus.PASSED
                : ReviewCheckStatus.NEEDS_REVIEW,
            reason: {
                messageKey: 'Component(ResearchReviewProcess):reason-enter-substance-name',
                fallbackMessage: 'Enter the substance name.',
            },
        },
        {
            id: 'chemity-link',
            status: link && link.substanceId && link.status === 'accepted'
                ? ReviewCheckStatus.PASSED
                : ReviewCheckStatus.NEEDS_REVIEW,
            reason: {
                messageKey: 'Component(ResearchReviewProcess):reason-link-chemity-substance',
                fallbackMessage: 'Select the matching Chemity substance.',
            },
        },
    ],
    facts: [
        { id: 'has-cas', value: isNonEmpty(substance.casNumber) },
        { id: 'has-ec', value: isNonEmpty(substance.ecNumber) },
        {
            id: 'has-concentration',
            value: !!(substance.concentration
                && substance.concentration.value !== null
                && typeof substance.concentration.value !== 'undefined'),
        },
    ],
})

const mergeEvaluation = (target, addition = {}) => ({
    checks: target.checks.concat(addition.checks || []),
    facts: target.facts.concat(addition.facts || []),
})

const createSubstanceReviewCheckerRegistry = ({ checkers = [], addons = [] } = {}) => Object.freeze({
    evaluate(input) {
        let evaluation = defaultSubstanceChecker(input)
        evaluation = checkers.concat(addons).reduce((result, checker) => (
            mergeEvaluation(result, checker(input))
        ), evaluation)

        return {
            ...evaluation,
            status: evaluation.checks.some(check => check.status === ReviewCheckStatus.NEEDS_REVIEW)
                ? ReviewCheckStatus.NEEDS_REVIEW
                : ReviewCheckStatus.PASSED,
        }
    },
})

const substanceReviewCheckerRegistry = createSubstanceReviewCheckerRegistry()

export {
    ReviewCheckStatus,
    createSubstanceReviewCheckerRegistry,
    substanceReviewCheckerRegistry,
}

export default substanceReviewCheckerRegistry
